import { useTenantFeatureFlagsQuery } from '@data/tenants';

/**
 * Whether this tenant's newsletter is switched on — `tenant.features.newsletter`, a SuperAdmin
 * kill switch published to the site through GET /tenants/feature-flags.
 *
 * Flags that are absent or not loaded yet read as on, the same rule the API applies, so a failed
 * flags request never hides a live tenant's form. This only decides what renders: the API refuses
 * newsletter requests on its own when the flag is off.
 */
export const useIsNewsletterEnabled = (): boolean => {
  const { data: featureFlags } = useTenantFeatureFlagsQuery();
  return featureFlags?.newsletter !== false;
};
